import { render, staticRenderFns } from "./catOthers.vue?vue&type=template&id=1fec148f&scoped=true"
import script from "./catOthers.vue?vue&type=script&lang=js"
export * from "./catOthers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fec148f",
  null
  
)

export default component.exports